import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Controlla se l'utente ha già chiuso il banner in passato
        const consent = localStorage.getItem('cookie_notice_dismissed');
        if (!consent) {
            // Piccolo delay per non apparire istantaneamente al caricamento
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleDismiss = () => {
        // Salva la preferenza nel localStorage per non mostrarlo più
        localStorage.setItem('cookie_notice_dismissed', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-[100] animate-fade-in">
            <div className="bg-white p-5 rounded-2xl shadow-2xl border border-gray-100 max-w-sm md:max-w-md flex flex-col gap-4 relative">

                {/* Header con Icona */}
                <div className="flex items-start gap-3">
                    <div className="p-2 bg-brand/10 rounded-full text-brand shrink-0">
                        <Cookie className="w-5 h-5" />
                    </div>
                    <div className="pr-6">
                        <h4 className="font-bold text-gray-900 text-sm mb-1 font-serif">Cookie Notice</h4>
                        <p className="text-xs text-gray-500 leading-relaxed">
                            We use cookies to ensure you get the best experience on our website, including secure payment processing via Stripe.
                            By continuing, you agree to our use of cookies.
                        </p>
                    </div>
                </div>

                {/* Pulsanti Azione */}
                <div className="flex items-center gap-3 mt-1">
                    <button
                        onClick={handleDismiss}
                        className="flex-1 bg-gray-900 text-white text-xs font-bold py-2.5 px-4 rounded-xl hover:bg-black transition-colors shadow-md"
                    >
                        Got it
                    </button>
                    <Link
                        to="/privacy"
                        className="text-xs font-bold text-gray-500 hover:text-brand transition-colors px-2"
                    >
                        Privacy Policy
                    </Link>
                </div>

                {/* Tasto Chiudi (X) in alto a destra */}
                <button
                    onClick={handleDismiss}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-900 p-1 bg-gray-50 rounded-full transition-colors"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;